export enum UserStatus {
  PENDING = 1,
  ACTIVE = 2,
  INACTIVE = 9,
}
